<template>
  <v-dialog v-model="dialog" max-width="1024">
    <template v-slot:activator="{ on: onDialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: onTooltip }">
          <v-btn :color="error ? 'error' : 'primary'" dark v-on="{ ...onDialog, ...onTooltip}" outlined block  :height="fullHeight ? '100%' : ''">
            {{ catalog ? catalog.classCode : 'Выбрать' }}
          </v-btn>
        </template>
        <span>{{ catalog ? catalog.classNameRu : 'Выберите икпу код' }}</span>
      </v-tooltip>
    </template>

    <v-card>
      <v-card-title>
        Выбор ИКПУ кода
      </v-card-title>
      <v-card-text>
        <v-autocomplete :items="catalogs" v-model="classCode" @update:search-input="onSearch" @change="onChange"
                        item-value="classCode" :no-filter="true" :dense="true" :clearable="true" :disabled="disabled">
          <template v-slot:no-data>
            <v-list-item> По данному фильтру нет данных</v-list-item>
          </template>
          <template v-slot:selection="{ item }">
            <h4> {{ item.classCode }} {{ item.classNameRu }} </h4>
          </template>

          <template v-slot:item="{ item }">
            <h4> {{ item.classCode }} {{ item.classNameRu }} </h4>
          </template>
        </v-autocomplete>
      </v-card-text>
      <v-card-actions>
        <v-btn href="https://tasnif.soliq.uz/classifier/info/download/excel-file" text target="_blank"
               color="primary">Скачать реестр классов
        </v-btn>
        <v-spacer/>
        <v-btn color="primary" text @click="dialog = false">
          Закрыть
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import InvoiceService from "@/services/invoice.service";
import _ from "underscore";
import mappers from "@/helpers/mappers";

export default {
  name: "SelectCatalogCodeDialog",
  props: ['defaultValue', 'error', 'fullHeight', 'disabled'],
  data() {
    return {
      dialog: false,
      classCode: null,
      catalog: null,
      catalogs: [],
      isLoading: false,
      filterTimerId: null,
      lastSearch: "",
      autoSupportDefaultValue: false
    }
  },
  methods: {
    onChange() {
      this.catalog = null
      if (this.classCode) {
        this.catalog = _.find(this.catalogs, (c) => {
          return c.classCode === this.classCode;
        }) || null;
      }
      this.$emit("input", this.catalog);
      this.$emit("change", this.catalog);
    },
    onSearch: _.debounce(function (search) {
      if (search && this.lastSearch !== search)
        this.filter(search);
    }, 500),
    filter(search) {
      const query = search;
      InvoiceService.getItemCatalogs({limit: 10, search: query})
          .then((response) => {
            this.lastSearch = query
            this.catalogs = _.map(response.data, (c) => {
              return mappers.mapInvoiceItemCatalog(c)
            })

            if (this.autoSupportDefaultValue)
              if (this.catalogs.length === 1 && this.catalogs[0].classCode === this.defaultValue)
                this.onChange()
          })
          .finally(() => {
            this.isLoading = false;
          })
    },
  },
  created() {
    if (this.defaultValue && typeof(this.defaultValue) === 'string') {
      this.classCode = this.defaultValue
      this.autoSupportDefaultValue = true
      this.filter(this.classCode)
    } else {
      this.filter("");
    }
  },
  watch: {
    defaultValue() {
      if (this.defaultValue && typeof(this.defaultValue) === 'string') {
        this.classCode = this.defaultValue
        this.autoSupportDefaultValue = true
        this.filter(this.classCode)
      }
    }
  }
}
</script>

<style scoped>

</style>